export default __webpack_public_path__ + "static/media/portfolio-48.820b54f8.jpg";